import { Component, OnInit, Input } from '@angular/core';
import { Partner } from '@fitscovery/partner/data-access';
import { ImageDescription } from '@fitscovery/partner/data-access';

@Component({
  selector: 'fitscovery-feature-default-template',
  templateUrl: './feature-default-template.component.html',
  styleUrls: ['./feature-default-template.component.scss'],
})
export class FeatureDefaultTemplateComponent implements OnInit {
  @Input() partner: Partner;
  @Input() imageDescriptions: ImageDescription[];

  sections: ImageDescription[];

  constructor() {
  }

  ngOnInit(): void {
  }


}
